const release = '0.13.2'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js